import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet/vehicle-types')({
  component: lazyRouteComponent(() => import('&/features/settings/fleet/pages/vehicle-types-page')),
  staticData: { titleKey: 'vehicleTypes' },
});
